$(document).ready(function(){
  $(".variant-input-new :radio").on("click", function() {
    var val = $(this).attr("value");
    //console.log(val);
    $(this).parents(".variant-wrapper-new").find(".variant__label").find('.variant__label-info').text(val);
    
  });
  var get_selected = $(".variant-input-non-color :radio:checked").parents(".variant-input").addClass("active-top");
  $(".variant-input-non-color :radio").on("change", function(){
    var val = $(this).attr("value");
    $(this).parents(".variant-input").addClass("active-top");
    $(this).parents(".variant-input").prevAll(".variant-input").removeClass("active-top");
    $(this).parents(".variant-input").nextAll(".variant-input").removeClass("active-top");
  })
   
  var optVal= $(".product-single__variants option:selected").val();
  //console.log(optVal);
   var optVale= $(".variant-specific-description").find(".variant-specific").attr("data-id");
    //console.log(optVale);
   $(".variant-specific-description").find(".variant-specific").hide();
   $(".variant-specific-description").find(".variant-specific[data-id='"+optVal+"']").show();
   $(".variant-specific-video").find(".variant-specific").hide();
   $(".variant-specific-video").find(".variant-specific").find("iframe").removeAttr("src");
   var optValed= $(".variant-specific-video").find(".variant-specific").attr("data-id");
   $(".variant-specific-video").find(".variant-specific[data-id='"+optVal+"']").show();
   var url = $(".variant-specific-video").find(".variant-specific[data-id='"+optVal+"']").find("iframe").attr("data-src");
   $(".variant-specific-video").find(".variant-specific[data-id='"+optVal+"']").find("iframe").attr("src",url);
});

  $(document.body).on('change',".product-single__variants",function () {
   var optVal= $(".product-single__variants option:selected").val();
   //console.log(optVal);
   var optVale= $(".variant-specific-description").find(".variant-specific").attr("data-id");
   //console.log(optVale);
   $(".variant-specific-description").find(".variant-specific").hide();
   $(".variant-specific-description").find(".variant-specific[data-id='"+optVal+"']").show(); 
   var optValed= $(".variant-specific-video").find(".variant-specific").attr("data-id");
   $(".variant-specific-video").find(".variant-specific").hide();
   $(".variant-specific-video").find(".variant-specific").find("iframe").removeAttr("src"); 
   $(".variant-specific-video").find(".variant-specific[data-id='"+optVal+"']").show();
   var url = $(".variant-specific-video").find(".variant-specific[data-id='"+optVal+"']").find("iframe").attr("data-src");
   $(".variant-specific-video").find(".variant-specific[data-id='"+optVal+"']").find("iframe").attr("src",url); 
  });


 //var slider = $('.variant_input-color-wrap');

  // var init = {
  //   dots: false,
  //   arrows: true,
  //   infinite: false,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true,
  //   prevArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg>',
  //   nextArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>',
  //   variableWidth:true,
  //   swipe:true
  // };

  // var owl = {
  //   items: 3,
  //   margin: 10,
  //   loop: true,
  //   nav: true
  // };
  //slider.not(".slick-initialized").slick(init);
//  if ($(window).width() < 576) {
    //slider.not(".slick-initialized").slick(init);
    //slider.slick("refresh");
//  } else if (slider.hasClass("slick-initialized")) {
    //slider.slick("unslick");
//  }

  // $(window).on("load resize", function () {
  //   if ($(window).width() < 576) {
  //     slider.not(".slick-initialized").slick(init);
  //     slider.slick("refresh");
  //   } else if (slider.hasClass("slick-initialized")) {
  //     slider.slick("unslick");
  //   }
  // });

 $('.product-slideshow-new').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    focusOnSelect: true,
    infinite: false,
    asNavFor: '.product__thumbs--new',
    prevArrow: '<div class="slick-custom-top-arrow slick-prev-top-arr"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></div>',
    nextArrow: '<div class="slick-custom-top-arrow slick-next-top-arr"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></div>',
    responsive: [
    {
      breakpoint: 590,
      settings: {
        dots: true
      }
    }
      ]
  });
  $('.product__thumbs--new').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.product-slideshow-new',
    dots: false,
    arrows: true,
    infinite: false,
    draggable:false,
    focusOnSelect: true,
    prevArrow: '<div class="slick-custom-arrow slick-prev-arr"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></div>',
    nextArrow: '<div class="slick-custom-arrow slick-next-arr"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></div>',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    } 
    ]
  });

  
//START COLOR VARIANT SLIDER
//   $('.variant_input-color-wrap').owlCarousel({
//     loop: false,
//     margin: 0,
//     dots: true,
//     nav: true,
//     items: 5,
// })
//END COLOR VARIANT SLIDER
  imgFilter();

  swatchImagesUpdate();

  $(document).on('click','.product__thumb-item', function(e){
      e.preventDefault()
      e.stopPropagation()
  });
  
   $(".variant-input-new :radio").on('click', function(){
      imgFilter();   
      swatchImagesUpdate();
   });

  $(".size-imgs").on("click",function(){
    var vl = $(this).attr("data-val");
    $(this).parents(".size-swatches").siblings("input").trigger("click");
    $(".size-imgs").removeClass("is-selected");
    $(this).addClass("is-selected");
  });

  var color = $(".variant-input-non-color").find(":radio:checked").data('filter');

  $('.product-slideshow-new').on('afterChange', function(event, slick, currentSlide, nextSlide){
    //console.log(currentSlide);
    $('[data-slick-index="'+currentSlide+'"]').addClass("is-selected");
    $('[data-slick-index="'+currentSlide+'"]').siblings().removeClass("is-selected");
  });

  function imgFilter(){
      var colorr = $(".variant-input-with-color").find(":radio:checked").data('filter');
      var filter = $(".variant-input-non-color").find(":radio:checked").data('filter');
      //console.log(color+filter);
      if ( colorr == "rustique" )
      {
        colorr  = "old-fashioned";
      }
    else if ( colorr == "noir" )
    {
      colorr  = "black";
    }
    else if ( colorr == "bleu" )
    {
      colorr  = "blue";
    }
    else if ( colorr == "bois-naturel" )
    {
      colorr  = "natural-wood";
    }
    else if ( colorr == "vert" )
    {
      colorr  = "green";
    }
    else if ( colorr == "rouge" )
    {
      colorr  = "red";
    }
    else if ( colorr == "burgundy" )
    {
      colorr  = "burgundy";
    }
    if ( filter == "petite" )
    {
      filter = "small";
    }
    else if ( filter == "moyenne" )
    {
      filter = "medium";
    }
    else if ( filter == "grande" )
    {
      filter = "large";
    }
      var final = colorr+"-"+filter;
      console.log(color);
      console.log(filter);
      console.log(final);
      $(".product__photos").addClass("images-loading");
      
        $(".product-slideshow-new").slick('slickUnfilter');
        var p_title = $(".product__photos").attr("p-title");
        var parents = $('.image-wrap img[alt="'+final+'"], .image-wrap img[alt="'+p_title+'"]').parents('.product-main-slide');
        $(".product-slideshow-new").slick('slickFilter',parents);
        $(".product-slideshow-new").slick('refresh');
        
        $(".product__thumbs--new").slick('slickUnfilter');
        var p_title = $(".product__photos").attr("p-title");
        var thumbs = $('.image-wrap img[alt="'+final+'"], .image-wrap img[alt="'+p_title+'"]').parents('.product__thumb-item');
        //console.log(thumbs);
        $(".product__thumbs--new").slick('slickFilter',thumbs);
        $(".product__thumbs--new").slick('refresh');
        
        $(".product__thumbs--new .slick-track").addClass("stoptransform");
        $(".product-slideshow-new .slick-list").addClass("flickity-viewport");
        color = filter;
      
      setTimeout(function(){
          var varimg= $(".product-single__variants option:selected").attr("data-pos");
          var index = $(".product-main-slide[data-index='"+varimg+"']").attr("data-slick-index");
          var arrw = $(".product__thumbs--new .slick-arrow").length;
          if(arrw == 0)
          {
            $(".product__thumbs--new .slick-track").addClass("stoptransform");
          }
          else
          {
            $(".product__thumbs--new .slick-track").removeClass("stoptransform");
          }
          $('.product-slideshow-new').slick('slickGoTo', index);
          $(".product__photos").removeClass("images-loading");
      },500);
  }

function swatchImagesUpdate(){
  
  var size = $(".variant-input-non-color").find("input:checked").attr("data-filter");
  //console.log(size);
  var color = $(".variant_input-color").find("input:checked").val();
  $(".size-imgs").each(function(){
    var v1 = $(this).attr("data-val");
    var v2 = $(".variant_input-color").find("input:checked").attr("data-filter");
    var file = v1+"-"+v2+".png";
    var url = $(".variant_input-color").find("label").attr("img");
    url = url.split("/assets/");
    var fnlUrl = url[0]+"/assets/"+file;
    $(this).find("img").attr("src",fnlUrl);
  });
  // $(".variant-input-with-color").each(function(){
  //   var v1 = $(".variant-input-non-color").find("input:checked").attr("data-filter");
  //   var v2 = $(this).find("input").attr("data-filter");
  //   var file = v1+"-"+v2+".png";
  //   var url = $(".variant_input-color").find("label").attr("img");
  //   url = url.split("/assets/");
  //   var fnlUrl = url[0]+"/assets/"+file;
  //  // $(this).find("label").css({"background-image":"url("+fnlUrl+")"});
  // });
  $(".size-imgs").removeClass("is-selected");
  $(".size-imgs[data-val='"+size+"']").addClass("is-selected");
}

$(".size-guide-trigger").on("click",function(e){
  e.preventDefault();
  var trget = $(this).attr("href");
  $(".size-modal-loader").show();
  $(".size-modal").show();
  $("body").addClass("size-modal-open");
  $.ajax({
    type: 'GET',
    url: trget,
    dataType: 'HTML',
    success: function(response) {
        var data = $(response);
        data = data.find("#MainContent").html();
        $(".size-modal-loader").hide();
        $(".size-modal .popup-content").html(data);
    },
    error: function() {
      console.log('There was an error adding the item(s) to your cart.');
    }
  });
});

$(".size-modal .close").on("click",function(){
  $(this).siblings(".popup-content").html("");
  $(this).parents(".size-modal").hide();
  $("body").removeClass("size-modal-open");
});


var hasEnable = $(".checkout-qty-popup").length;
//alert(hasEnable);
if(hasEnable != 0)
{
  $(document).on("click","[name='checkout']",function(e){
    var cartCount = 0;
    $("#CartDrawer .js-qty__num,.template-cart .js-qty__num").each(function(){
      var Protype = $(this).attr('datatype');
      if (Protype == 'Hand Percussion'){
         var vl = $(this).val();
         cartCount += parseInt(vl);
      }
    });
    if(cartCount == 2)
    {
      e.preventDefault();
      $(".checkout-qty-popup").show();
    }
  });
  
  $(".checkout-popup-close").on("click",function(){
    //$(this).parents(".checkout-qty-popup").hide();
       window.location.href = '/checkout';
  });
    $(".check-pop-close").on("click",function(){
    $(this).parents(".checkout-qty-popup").hide();
      // window.location.href = '/checkout';
  });
  
  $(".checkout-popup-procced").on("click",function(){
    var pid =$(this).attr("data-productid");
  var numItems = $('#productoptions_'+pid+'>.product-size').length; 
   // alert(pid);
   // alert(numItems);

 var op=[];     
    for (var i = 1; i <= numItems; ++i) {
    var conceptName = $('#productoptions_'+pid+'> #options_'+i+' > select.sizes').find(":selected").val();
    op.push(conceptName);   
    }
      
     var text = op.join(" / ");
   //  alert(text);

  var quantity = $('#Quantity-'+pid).val();
     //alert(quantity);
    //window.location.href = '/checkout

     $("#bundleid_"+pid+" > option").each(function() {
     
    var textv= $(this).text();
    var textvaluev= $(this).val();
     
    var optxt = this.text;
       if(optxt==text){
        // alert(text);
    // alert(optxt);

         $.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: quantity,
  id: textvaluev
},
  dataType: 'json', 
 success: function (data) { 
 //location.href = '/checkout';
   $(".checkout-popup-procced.popbtn").html("Added");
  // $("#CartDrawerForm").load(location.href + " #CartDrawer");
 $(".pop-err").html("");
   document.dispatchEvent(new CustomEvent('cart:build'));
setTimeout(function() {
    $(".checkout-popup-procced.popbtn").html("Add");
  }, 5000);
 
 },
            error: function(jqXHR, textStatus, errorThrown){
             if (jqXHR.status === 422) {
                    // display error wherever you want to  
                    console.log(jqXHR.responseText);
                $(".pop-err").html("*This variant is sold out. Add another one.");
              
                }
		
           }
 });


	   
       }
  });
     });
}
